'use client';

import { BlocksContent, BlocksRenderer } from '@strapi/blocks-react-renderer';

import { StrapiImage } from '@/lib/strapi';

import { AppImage } from '../AppImage';

export type RichTextRendererProps = {
    content: BlocksContent;
};

export function RichTextRenderer({ content }: RichTextRendererProps) {
    if (!content) {
        return null;
    }

    return (
        <BlocksRenderer
            content={content}
            blocks={{
                image: ({ image }) => (
                    <AppImage
                        image={image as StrapiImage}
                        className="mx-auto max-w-5xl rounded-xl"
                    />
                ),
            }}
        />
    );
}
